import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import ContentfulOffer from '@entries/contentful-offer'
import { withDisplayName } from '@hocs/with-display-name'
import { OpenFormButton } from '@layouts/open-form-button'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  objectFit: 'contain',
  width: 'auto',
  height: 'auto',
}

const ContentfulPageImageTitleLandingHero: Utils.EntryFC<
  Queries.ContentfulPageImageTitleLandingHeroFragment
> = ({
  content: { offerRef, image },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <div
    className="text-center laptop:text-left"
    {...entryInspectorProps()}
    {...fieldInspectorProps({
      fieldId: 'offerRef',
    })}
  >
    <Entry
      content={offerRef}
      mapping={{
        [ContentType.ContentfulOffer]: ContentfulOffer,
      }}
    />
    <OpenFormButton />
    {image && (
      <div
        className="hidden tablet:block"
        {...fieldInspectorProps({
          fieldId: 'image',
        })}
      >
        <AssetOptionsContext.Provider value={assetOptions}>
          <Entry
            content={image}
            mapping={{
              [ContentType.ContentfulAsset]: ContentfulAsset,
            }}
          />
        </AssetOptionsContext.Provider>
      </div>
    )}
  </div>
)

export const query = graphql`
  fragment ContentfulPageImageTitleLandingHero on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    image {
      ...ContentfulDefaultAsset
    }
    offerRef {
      ...ContentfulOffer
    }
  }
`

export default withDisplayName(
  ContentfulPageImageTitleLandingHero,
  'ContentfulPageImageTitleLandingHero'
)
